export default __webpack_public_path__ + "img/06e5b1aba745a745edee68ce462a2a7d.svg";